import RecentSearch from 'src/search2/RecentSearch';

export default class Settings {

    public static readonly minSearchPaneSize = 110;
    public static readonly minVersionsPaneSize = 200;

    private static readonly defaultOpenTabs = ['versions'];
    private static readonly defaultSearchPaneSize = 110;
    private static readonly defaultVersionsPaneSize = 350;
    private static readonly defaultTabPaneSize = 30; // %
    //private static readonly defaultTabSplitPosition = 50; // %

    public getSelectedVersions(): number[] {
        const json = localStorage.getItem('selectedVersions') || '[]';
        try {
            const indexes = JSON.parse(json);
            if (!Array.isArray(indexes)) {
                throw new Error();
            }
            return indexes;
        } catch (error) {
            return [];
        }
    }

    public setSelectedVersions(indexes: number[]): void {
        localStorage.setItem('selectedVersions', JSON.stringify(indexes));
    }

    /*public getVersionsPaneVisible(): boolean {
        const visible = localStorage.getItem('versionsPaneVisible');
        return visible === '1' || visible === null; // Default is "visible".
    }

    public setVersionsPaneVisible(visible: boolean): void {
        localStorage.setItem('versionsPaneVisible', visible ? '1' : '0');
    }*/

    public getOpenTabs(): string[] {
        let tabIds = Settings.defaultOpenTabs;
        const json = localStorage.getItem('openTabs');
        if (json !== null) {
            try {
                const parsed = JSON.parse(json);
                if (Array.isArray(parsed)) {
                    tabIds = parsed;
                }
            } catch (error) {} // tslint:disable-line:no-empty
        }
        // For now only return the state of the versions tab as we don't
        // want to start the app with the search or lexicon tabs open.
        return tabIds.filter(id => id === 'versions');
    }

    public setOpenTabs(tabIds: string[]): void {
        localStorage.setItem('openTabs', JSON.stringify(tabIds));
    }

    public getSearchPaneSize(): number {
        const savedSize = localStorage.getItem('searchPaneSize');
        const size = savedSize ? Number(savedSize) : Settings.defaultSearchPaneSize;
        return Math.max(size, Settings.minSearchPaneSize);
    }

    public setSearchPaneSize(size: number): void {
        localStorage.setItem('searchPaneSize', String(size));
    }

    public getVersionsPaneSize(): number {
        const savedSize = localStorage.getItem('versionsPaneSize');
        const size = savedSize ? Number(savedSize) : Settings.defaultVersionsPaneSize;
        return Math.max(size, Settings.minVersionsPaneSize);
    }

    public setVersionsPaneSize(size: number): void {
        localStorage.setItem('versionsPaneSize', String(size));
    }

    public getTabPaneSize(): number {
        const size = localStorage.getItem('tabPaneSizePercent');
        return size ? Number(size) : Settings.defaultTabPaneSize;
    }

    public setTabPaneSize(size: number): void {
        localStorage.setItem('tabPaneSizePercent', String(size));
    }

    /*public getTabSplitPosition(): number {
        const position = localStorage.getItem('tabSplitPosition');
        return position ? Number(position) : Settings.defaultTabSplitPosition;
    }

    public setTabSplitPosition(position: number): void {
        localStorage.setItem('tabSplitPosition', String(position));
    }*/

    public getRecentSourceSearches(): RecentSearch[] {
        const json = localStorage.getItem('recentSourceSearches') || '[]';
        try {
            const searches = JSON.parse(json);
            if (!Array.isArray(searches)) {
                throw new Error();
            }
            return searches.map((search: RecentSearch) => new RecentSearch(search.text, search.options));
        } catch (error) {
            return [];
        }
    }

    public setRecentSourceSearches(searches: RecentSearch[]): void {
        localStorage.setItem('recentSourceSearches', JSON.stringify(searches));
    }
}
